import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { DEFAULT_NUMBER, DEFAULT_TYPE_ID } from './constants';

function NumberTab() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const typeId = parseInt(params.get('type') || DEFAULT_TYPE_ID);
  const isNotOneLesson = params.get('comprehensive') !== '0';
  if (typeId !== 1 || isNotOneLesson) return null;

  const number = parseInt(params.get('number') || DEFAULT_NUMBER);

  const handleChange = (selectedNumber: number) => {
    if (selectedNumber && selectedNumber !== number) {
      params.set('number', selectedNumber.toString());
    } else {
      params.delete('number');
    }
    navigate(`${location.pathname}?${params}`);
  };

  return (
    <div className='mx-auto my-4 flex w-full max-w-sm items-center gap-3 sm:px-0'>
      <span className='hidden sm:inline'>دور:</span>
      <div className='flex flex-1 gap-1 space-x-0.5 rounded-lg bg-gray-200 p-1'>
        {['یک', 'دو', 'سه', 'چهار'].map((category, index) => (
          <button
            key={category}
            onClick={() => handleChange(index + 1)}
            className={classNames(
              'w-full rounded-lg py-2 text-xs font-medium leading-5 text-gray-800 xs:text-sm',
              'ring-white ring-opacity-60 ring-offset-2 ring-offset-gray-600 focus:outline-none',
              index + 1 === number
                ? 'bg-white shadow focus:ring-2'
                : 'text-gray-200 hover:bg-white/[0.12] hover:text-white'
            )}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
}

export default NumberTab;
